document.addEventListener('DOMContentLoaded', function () {
  const openFormBtn = document.getElementById('open-form-btn');
  const formContainer = document.getElementById('yopro-form');
  const formSuccess = document.getElementById('form-success');
  const form = formContainer.querySelector('form');

  // Función para verificar si el usuario ya se ha inscrito y si han pasado 5 segundos
  function checkSubscriptionStatus() {
    const subscribed = localStorage.getItem('yoproSubscribed');
    const subscriptionTime = localStorage.getItem('yoproSubscriptionTime');
    const currentTime = Date.now();

    // Si hay un estado de suscripción, verificar si han pasado más de 5 segundos
    if (subscribed === 'true' && subscriptionTime) {
      const timeElapsed = currentTime - parseInt(subscriptionTime, 10);
      if (timeElapsed > 5000) { // 5000 milisegundos = 5 segundos
        // Limpiar el localStorage si han pasado más de 5 segundos
        localStorage.removeItem('yoproSubscribed');
        localStorage.removeItem('yoproSubscriptionTime');
        // Mostrar el botón y ocultar el mensaje de éxito y el formulario
        openFormBtn.style.display = 'block';
        formContainer.style.display = 'none';
        formSuccess.style.display = 'none';
      } else {
        // Si no han pasado 5 segundos, ocultar el botón y el formulario, y mostrar el mensaje de éxito
        openFormBtn.style.display = 'none';
        formContainer.style.display = 'none';
        formSuccess.style.display = 'block';
      }
    } else {
      // Si no está inscrito, mostrar el botón y ocultar el mensaje de éxito y el formulario
      openFormBtn.style.display = 'block';
      formContainer.style.display = 'none';
      formSuccess.style.display = 'none';
    }
  }

  // Verificar el estado al cargar la página
  checkSubscriptionStatus();

  // Mostrar el formulario al hacer clic en el botón, si no está inscrito
  if (openFormBtn && formContainer) {
    openFormBtn.addEventListener('click', function () {
      formContainer.style.display = 'block';
      openFormBtn.style.display = 'none';
    });
  }

  // Escuchar el evento de envío del formulario
  if (form) {
    form.addEventListener('submit', function (event) {
      // Forzar que accepts_marketing sea false
      let acceptsMarketingInput = form.querySelector('input[name="contact[accepts_marketing]"]');
      if (!acceptsMarketingInput) {
        acceptsMarketingInput = document.createElement('input');
        acceptsMarketingInput.type = 'hidden';
        acceptsMarketingInput.name = 'contact[accepts_marketing]';
        acceptsMarketingInput.value = 'false';
        form.appendChild(acceptsMarketingInput);
      } else {
        acceptsMarketingInput.value = 'false';
      }

      // Verificar si el formulario es válido (pasa las validaciones HTML5)
      if (form.checkValidity()) {
        // Guardar el estado de inscripción y la marca de tiempo en localStorage
        localStorage.setItem('yoproSubscribed', 'true');
        localStorage.setItem('yoproSubscriptionTime', Date.now().toString());
        // Actualizar la interfaz inmediatamente
        checkSubscriptionStatus();
      }
    });
  }
});